export class Horse {
  birth: string;
  created_at: string;
  deleted_at: string;
  description: string;
  farm: Farm;
  farm_id: number;
  gender_id: number;
  history: Array<string>;
  id: number = null;
  instructor_id: number;
  microchip: any;
  microchip_number: number;
  name: string;
  updated_at: string;
  vetclinic_id: number;
  is_in_food_chain: boolean = true;
  in_training: boolean = false;
  is_active: boolean;
  is_eligible?: boolean;
  has_active_vaccinations: boolean;
  eligible_forms: string = "";
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/classes/horse.ts